import { Component, OnInit } from "@angular/core";
import { FormField } from "../../../interfaces/form-field.model";
import { faPrint, faEraser } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { COEBidsDetailsReportService } from "src/app/services/autopac-reports/coe-bids-details-report.service";

@Component({
  selector: "coe-bids-details-report",
  templateUrl: "./coe-bids-detail-report.component.html",
  styleUrls: ["./coe-bids-detail-report.component.css"],
})
export class COEBidsDetailsReportComponent implements OnInit {
  faPrint = faPrint;

  lockBtn = true;

  form!: FormField[];

  constructor(
    private notifier: NotifierService,
    private COEBidsDetailsReportService: COEBidsDetailsReportService,
  ) {}

  updateFields(event: any): void {
    this.form = event.fields;
    if (this.getFieldValue("BidDate")) {
      this.lockBtn = false;
    } else {
      this.lockBtn = true;
    }
  }

  ngOnInit() {
    this.setUpFormFields();
  }

  private setUpFormFields(): void {
    this.form = [
      {
        type: "select",
        id: "BidType",
        label: "Bid Type",
        options: [
          {
            value: "ALL",
            display: "ALL",
          },
          {
            value: "K",
            display: "K",
          },
          {
            value: "C",
            display: "C",
          },
          {
            value: "P",
            display: "P",
          },
        ],
        value: "ALL",
      },
      {
        type: "date",
        id: "BidDate",
        label: "Bid Date (dd/mm/yyyy)",
        required: true,
      },
      {
        type: "select",
        id: "Format",
        label: "Select Format",
        options: [
          {
            value: "pdf",
            display: "PDF",
          },
          {
            value: "excel",
            display: "EXCEL",
          },
          {
            value: "both",
            display: "BOTH",
          },
        ],
        value: "pdf",
      },
    ];
  }

  printStatus(): void {
    const searchData = this.populateSearchBody();
    this.COEBidsDetailsReportService.COEBidsDetailsReport(
      searchData.BidDate,
      searchData.BidType,
    ).subscribe({
      next: (response) => {
        if (this.getFieldValue("Format") == "pdf") {
          window.open(response.body.Name, "_blank");
        } else if (this.getFieldValue("Format") == "excel") {
          window.open(response.body.Value, "_blank");
        } else if (this.getFieldValue("Format") == "both") {
          window.open(response.body.Value, "_blank");
          window.open(response.body.Name, "_blank");
        }
      },
      error: (error) => {
        console.log(error);
        this.handleError("Error getting data", error);
      },
    });
  }

  private populateSearchBody(): any {
    return {
      BidType: this.getFieldValue("BidType"),
      BidDate: formatDate(
        this.getFieldValue("BidDate"),
        "dd/MM/yyyy",
        "en-US",
      ),
      Type: this.getFieldValue("Type"),
    };
  }

  private getFieldValue(id: string, index?: number): any {
    const field = this.form.find((f) => f.id === id);
    return index !== undefined ? field?.value[index] : field?.value;
  }

  private handleError(message: string, error: any): void {
    console.error(message, error);
    this.notifier.notify("error", message);
  }
}
